// ============================================================================
// Safe Care - Modale centrale professionnelle pour les pages de configuration
// Design épuré : centrée, border-radius 12px, ombre douce, au-dessus de tout
// Palette : couleurs par défaut de l'application (variables CSS)
// ============================================================================

import { Modal, Button } from 'antd';
import { ReactNode } from 'react';

interface SafeCarePageModalProps {
  title: string;
  open?: boolean;
  onBack: () => void;
  children: ReactNode;
  footerExtra?: ReactNode;
}

const SafeCarePageModal = ({ title, open = true, onBack, children, footerExtra }: SafeCarePageModalProps) => (
  <Modal
    open={open}
    onCancel={onBack}
    title={
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          fontSize: 16,
          fontWeight: 600,
          color: 'var(--darkblue)',
        }}
      >
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 28,
            height: 28,
            borderRadius: 8,
            background: 'var(--lightColor002)',
            color: 'var(--darkColor)',
            fontSize: 16,
          }}
        >
          ⚙
        </span>
        {title}
      </div>
    }
    width="92%"
    centered
    style={{
      top: 0,
      padding: 0,
      maxWidth: 'calc(100vw - 48px)',
    }}
    bodyStyle={{
      height: 'calc(100vh - 180px)',
      maxHeight: 'calc(100vh - 180px)',
      overflow: 'auto',
      padding: 20,
      background: 'var(--lightColor001)',
    }}
    className="safeCareModal"
    closable
    maskClosable={false}
    zIndex={2000}
    maskStyle={{ background: 'rgba(13,74,112, 0.32)', backdropFilter: 'blur(2px)' }}
    footer={[
      footerExtra,
      <Button
        key="back"
        onClick={onBack}
        style={{
          borderRadius: 8,
          borderColor: 'var(--colorOpaque060)',
          color: 'var(--darkColor)',
          fontWeight: 500,
        }}
      >
        Retour
      </Button>,
    ]}
  >
    {children}
  </Modal>
);

export default SafeCarePageModal;
